export const ADMIN_CUSTOMERS_REQUEST_DATA =
  'customers/ADMIN_CUSTOMERS_REQUEST_DATA';
export const ADMIN_CUSTOMERS_RECEIVE_DATA =
  'customers/ADMIN_CUSTOMERS_RECEIVE_DATA';
